export default {
  namespaced: true,
  
  state: () => ({
    whiteShade: 'pure',      // Default white shade
    hasShadows: true,        // Whether to show shadows
    borderStyle: 'light',    // Default border style
  }),
  
  mutations: {
    SET_WHITE_SHADE(state, shade) {
      state.whiteShade = shade;
    },
    
    TOGGLE_SHADOWS(state) {
      state.hasShadows = !state.hasShadows;
    },
    
    SET_BORDER_STYLE(state, style) {
      state.borderStyle = style;
    }
  },
  
  getters: {
    backgroundClass: state => `bg-white-${state.whiteShade}`,
    
    cardClass: state => {
      const shadow = state.hasShadows ? 'white-card-light-shadow' : 'white-card-no-shadow';
      return `bg-white-${state.whiteShade} ${shadow}`;
    },
    
    whiteShadeHex: state => {
      const shades = {
        'pure': '#FFFFFF',
        'pearl': '#FCFCFC',
        'soft': '#F8F8F8',
        'light': '#F5F5F5',
        'gray': '#EEEEEE'
      };
      return shades[state.whiteShade] || shades.pure;
    }
  },
  
  actions: {
    setWhiteTheme({ commit }, { shade = 'pure', hasShadows = true, borderStyle = 'light' }) {
      commit('SET_WHITE_SHADE', shade);
      commit('SET_BORDER_STYLE', borderStyle);
      if (hasShadows !== undefined) {
        if (hasShadows !== state.hasShadows) {
          commit('TOGGLE_SHADOWS');
        }
      }
    }
  }
};